import { DebounceModule } from "./debounce.module";
import { BaseModule } from "./base.module";
export class BootstrapNavigationBarModule extends BaseModule {

	constructor() {
		super();
		this.nav;
		this.mainNavigationContainerSelectorWithJumbotronAtTop = 'body.jumbotron-at-top .main-navigation-container';
		this.scrollTopNeutralClass = 'at-top';
		this.scrollTopPositiveClass = 'not-at-top';
		this.scrollTopFixedClass = 'fixed-top';
		this.navBarMarginElementClass = '.navbar-margin-element';
		this.logoWebsiteSelector = 'svg symbol[id^="icon-logo-website"]'; // initially shown website logo. Look up the symbols from generated design system svg assets
		this.logoFixedWebsiteSelector = 'svg symbol[id^="icon-logo-fixed-website"]'; //Look up the symbols from generated design system svg assets
		this.cachedHeight = 0;
		this.cachedHighestHeight = 0;
		this.cachedCollapseHeight = 0;
		this.debounceModule = new DebounceModule();
		this.fixed = false;
		this.hasMultipleWebsiteLogos = false;
	}
	initialize() {
		this.setEventListeners();
		if (window.location.hash.length > 1) {
			this.forceScrollToWindowHash();
		}
		// handle case where jumbotron is the first item of the page
		if (this.getNavWithJumbotronAtTop()) {
			// console.info('nav with jumbotron at top detected');
			this.handleResizeForNavWithJumbotronAtTop();
			const navbar = document.getElementById('navbar');
			if (navbar) {
				navbar.addEventListener('show.bs.collapse', (event) => {
					// get the first container
					this.cachedCollapseHeight = this.cachedHeight;
					console.log('cachedCollapseHeight', this.cachedCollapseHeight);
					let navContainer = document.querySelector('header .main-navigation-container');
					if (navContainer) {
						navContainer.classList.add('activated');
						this.navContainerActivated = true;
					}
				})
				navbar.addEventListener('hide.bs.collapse', (event) => {
					// get the first container
					// this.cachedHighestHeight = this.cachedCollapseHeight;
					// this.cachedHeight = this.cachedCollapseHeight;
					let navContainer = document.querySelector('header .main-navigation-container');
					if (navContainer) {
						navContainer.classList.remove('activated');
						this.cachedHeight = this.cachedCollapseHeight;
						this.cachedHighestHeight = this.cachedCollapseHeight;
						console.log('collapse', this.cachedHeight, this.cachedHighestHeight);
						this.getNavBarMarginElement().style.maxHeight = `0px`;
					}
				})


				navbar.addEventListener('hidden.bs.collapse', (event) => {
					this.navContainerActivated = false;
				})
			}
		}

		// handle main navigation container stuff
		if (this.getMainNavigationContainer()) {
			// console.info('main navigation container detected');
			this.handleScroll();
			this.handleLogoWebsite();
			document.addEventListener(
				'navigation-bar-height',
				this.handleBootstrapNavigationBarHeight
			);
			this.handleResizeForMainNavigationContainer();
		}
	}

	getMainNavigationContainer() {
		this.mainNavigationContainer = document.querySelector('.main-navigation-container');
		// console.log('getMainNavigationContainer', this.mainNavigationContainer);
		return this.mainNavigationContainer;
	}

	/**
	 * See if there are multiple logos and set class so that case can be handled in css
	 */
	handleLogoWebsite() {
		let logoWebsite = document.querySelector(this.logoWebsiteSelector);
		let logoFixedWebsite = document.querySelector(this.logoFixedWebsiteSelector);
		if (logoWebsite) {
			console.log('logoWebsite', logoWebsite);
		}
		if (logoFixedWebsite) {
			console.log('logoFixedWebsite', logoFixedWebsite);
		}
		else {
			let logoFixedWebsiteAssetUse = document.querySelector('.logo-fixed-website');
			if (logoFixedWebsiteAssetUse) {
				logoFixedWebsiteAssetUse.style.display = 'none';
			}
		}
		if (logoWebsite && logoFixedWebsite) {
			// there are multiple website logos, now set has-fixed-logo class on main nav container, so css can handle this case (i.e.: show or hide based on fixed-top or at-top state)
			this.hasMultipleWebsiteLogos = true;
			let mainNavigationContainer = this.getMainNavigationContainer();
			if (mainNavigationContainer) {
				mainNavigationContainer.classList.add('has-fixed-logo');
			}
		}
	}
	/**
	 * Allow for a self-contained empty element starting with id
	 * That will scroll to the target and account for the fixed nav height
	 */
	handleScrollTargets() {
		let scrollTargets = document.querySelectorAll('main div[id]:empty');
		if (scrollTargets) {
			// console.log('scrollTargets', scrollTargets);
			let navBarHeight = document.documentElement.style.getPropertyValue(`--nexus-navigation-bar-height-in-pixels`);
			// console.log('navbarHeight', navBarHeight);
			scrollTargets.forEach((scrollTarget) => {
				// scrollTarget.style.width = `100%`;
				scrollTarget.style.position = `absolute`;
				scrollTarget.style.height = `${navBarHeight}px`;
				scrollTarget.style.marginTop = `-${navBarHeight}px`;
			});
		}
	}

	getNavWithJumbotronAtTop() {
		this.nav = document.querySelector(this.mainNavigationContainerSelectorWithJumbotronAtTop); // get the first navbar
		// console.log('nav', this.nav);
		return this.nav;
	}

	// getNav() {
	// 	this.nav = this.getMainNavigationContainer; // get the first navbar
	// 	// console.log('nav', this.nav);
	// 	return this.nav;
	// }

	getNavBarMarginElement() {
		this.navBarMarginElement = document.querySelector(this.navBarMarginElementClass); // get the first navbar
		// console.log('navBarMarginElement', this.navBarMarginElement);
		return this.navBarMarginElement;
	}

	setEventListeners() {
		window.addEventListener('scroll', this.debounceModule.debounce((event) => {
			// if (this.navContainerActivated === false) {
			this.handleScroll();
			// }
		}, 0));
		window.addEventListener('resize', this.debounceModule.debounce((event) => {
			this.cachedHighestHeight = 0;
			this.handleResizeForNavWithJumbotronAtTop();
			this.handleResizeForMainNavigationContainer();
		}, 10));
		window.addEventListener('load', (event) => {
			this.handleWindowLoad(event);
			this.handleScroll();
		});

	}

	handleResizeForNavWithJumbotronAtTop() {
		if (this.getNavWithJumbotronAtTop()) {
			this.cachedHeight = this.getNavWithJumbotronAtTop().clientHeight;
			this.emitHeight();
		}
	}

	handleResizeForMainNavigationContainer() {
		if (this.getMainNavigationContainer()) {
			this.cachedHeight = this.getMainNavigationContainer().clientHeight;
			this.emitHeight();
		}
	}

	pollMainNavigationContainerHeight() {
		// console.log('handleWindowLoad');
		let handleAnimationFrameRequest = () => {
			this.emitHeight();
			if (this.navContainerActivated === false) {
				this.handleScroll();
			}
			if (this.getMainNavigationContainer()) {
				this.cachedHeight = this.getMainNavigationContainer().clientHeight;
			}

		};
		requestAnimationFrame(handleAnimationFrameRequest);
	}

	handleWindowLoad() {
		this.pollMainNavigationContainerHeight();
		// window.addEventListener('hashchange', (event) => {
		// 	console.info('hashchange event', event);
		// 	this.onHashChange(event);
		// });
	}

	onHashChange() {
		// if (window && window.location && window.location.hash) {
		// 	console.info('onHashChange', window.location.hash);
		// 	let target = document.querySelector(window.location.hash);
		// 	if (target) {
		// 		console.info('hashchange target', target);
		// 		var scrollTop = target.offsetTop;
		// 		window.scroll({
		// 			// left: 0,
		// 			top: scrollTop,
		// 		});
		// 	}
		// }
	}

	emitHeight() {
		//console.log('emitHeight', this.cachedHighestHeight);
		this.triggerEventOnElement(
			'navigation-bar-height',
			document,
			this.cachedHighestHeight
		);
		// set css variable
		document.documentElement.style.setProperty(`--nexus-navigation-bar-height`, `${this.cachedHighestHeight}px`);
		document.documentElement.style.setProperty(`--nexus-navigation-bar-height-in-pixels`, `${this.cachedHighestHeight}`);
	}

	handleScroll() {
		// console.log('handleScroll', this.getNavWithJumbotronAtTop().offsetHeight, this.cachedHeight, this.cachedHighestHeight);
		// if (window.location.pathname === `/`) {
		if (this.getNavWithJumbotronAtTop()) {
			this.cachedHeight = this.getNavWithJumbotronAtTop().offsetHeight;
			// if (this.cachedHeight > this.cachedHighestHeight) {
			this.cachedHighestHeight = this.getNavWithJumbotronAtTop().offsetHeight;
			// }
		}
		// console.log('cachedHeight', this.cachedHeight);

		if (this.getMainNavigationContainer() && this.getNavBarMarginElement()) {
			if (document.documentElement.scrollTop === 0) {
				this.getNavBarMarginElement().style.minHeight = 0;
				// this.getNavBarMarginElement().style.height = 0;
				this.getNavBarMarginElement().style.maxHeight = 0;
				this.getMainNavigationContainer().classList.add(this.scrollTopNeutralClass);
				if (this.fixed === false) {
					this.getMainNavigationContainer().classList.remove(this.scrollTopPositiveClass);
					this.getMainNavigationContainer().classList.remove(this.scrollTopFixedClass);
				}
			}
			if (document.documentElement.scrollTop > 0) {
				if (this.fixed === false) {
					this.getNavBarMarginElement().style.minHeight = `${this.cachedHighestHeight}px`;
					// this.getNavBarMarginElement().style.height = `${this.cachedHighestHeight}px`;
					this.getNavBarMarginElement().style.maxHeight = `${this.cachedHighestHeight}px`;
					if (this.getMainNavigationContainer()) {
						this.getMainNavigationContainer().classList.add(this.scrollTopPositiveClass);
					}
					if (this.getNavWithJumbotronAtTop()) {
						this.getNavWithJumbotronAtTop().classList.add(this.scrollTopFixedClass);
					}
				}
				if (this.getMainNavigationContainer()) {
					this.getMainNavigationContainer().classList.remove(this.scrollTopNeutralClass);
				}
			}
		}
		// this.emitHeight();
	}

	/**
	 * Pull up the first found jumbotron, which should always be the first visual composer item
	 * @param {*} event 
	  */
	handleBootstrapNavigationBarHeight(event) {
		// console.log('[Application] handleBootstrapNavigationBarHeight', event);
		if (event.data) {
			let height = event.data;
			// only get the first found!
			let element = document.querySelector(
				// 'header+.jumbotron'
				'.jumbotron-fixed .jumbotron-text-column'
			);
			if (element && element.style) {
				element.style.marginTop = `${height}px`;
			}
			// only get the first found!
			let element2 = document.querySelector(
				// only select it if it is the first item!
				// 'header+.jumbotron'
				'header+.jumbotron-fixed, header+main .jumbotron-fixed'
			);
			if (element2 && element2.style) {
				element2.style.marginTop = `-${height}px`;
			}
			// this.forceScrollToWindowHash();
		}
		// this.emitHeight();
	}

	forceScrollToWindowHash() {
		// if (window && window.location && window.location.hash) {
		// 	console.info('forceScrollToWindowHash', window.location.hash);
		// 	let target = document.querySelector(window.location.hash);
		// 	if (target) {
		// 		window.addEventListener('load', (event) => {
		// 			console.info('window loaded with dependencies loaded');
		// 			var scrollTop = target.offsetTop;
		// 			window.scroll({
		// 				// left: 0,
		// 				top: scrollTop,
		// 			});
		// 		});
		// 	}
		// }
	}
}